const noop = () => {};

export { noop };